import React from 'react'
import {
    UiContentWr,
    UiTopInputWr,
    UiTopInputHeading,
    UiContentCol,
    UiContentColWithSlider,
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
    UiTabContentWr,
    UiTabContent
} from "../../../components/common/UiPageElements"
import { UiCheckboxInput } from "../../../components/form/UiInput"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import {UiButtonPrimary} from "../../../components/form/UiButton"

export default function LoyaltySignUp(props) {
    
    return (
        <>
            <UiColTitleWr>
                <UiColTitle
                    title="Sign Up"
                    subtitle="Tell us about the store types that you might be interested in." />
            </UiColTitleWr>
            <UiSingleRow className="sb-signup-checkbox-wr">
                <UiCol lg="4">
                    <UiCheckboxInput label="Health & Beauty"/>
                </UiCol>
                <UiCol lg="4">
                    <UiCheckboxInput label="Home & Garden"/>
                </UiCol>
                <UiCol lg="4">
                    <UiCheckboxInput label="Travel"/>
                </UiCol>
                <UiCol lg="4">
                    <UiCheckboxInput label="Electronics"/>
                </UiCol>
                <UiCol lg="4">
                    <UiCheckboxInput label="Sport & Fitness"/>
                </UiCol>
                <UiCol lg="4">
                    <UiCheckboxInput label="Media"/>
                </UiCol>
                <UiCol lg="4">
                    <UiCheckboxInput label="Watches & Jewelery"/>
                </UiCol>
                <UiCol lg="4">
                    <UiCheckboxInput label="Fashion"/>
                </UiCol>
            </UiSingleRow>   
            <hr/>
            <UiSingleRow className="mt-4 sb-loyalty-signup-content">
                <UiCol lg="8" >
                    <p>Our retail partners would like to make direct contact with you. Please specify is you would like them to use any of the following ways to share their campaigns and promotions with you.</p>
                </UiCol>
                <UiCol lg="4" className="sb-signup-checkbox-wr mt-0">
                    <UiCheckboxInput label="Email"/>
                    <UiCheckboxInput label="SMS"/>
                    <UiCheckboxInput label="Phone"/>
                    <UiCheckboxInput label="Mail"/>
                </UiCol>
                <UiCol lg="5" className="offset-lg-7">
                    <UiButtonPrimary btnName="Sign Up" onClick={props.onClick} />
                </UiCol>
            </UiSingleRow>    
        </>
    )
}
